import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { OsobaSrodstvo } from './osoba-srodstvo';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-osoba-srodstvo-modal-update',
  templateUrl: './osoba-srodstvo-modal-update.component.html'
})
export class OsobaSrodstvoModalUpdateComponent extends BaseModalUpdateComponent<OsobaSrodstvo> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<OsobaSrodstvo>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
